<template>
    <div class="automation-trigger-settings">
        <p>
            {{ t('automations-form-triggers_config-product_group_stock-description') }}
        </p>

        <div class="field">
            <div v-if="groups.length > 0">
                <label
                    :class="{
                        label: true,
                        'label-danger': !isFieldValid('groupId'),
                    }"
                    >{{ t('automations-form-triggers_config-product_group_stock-group_label') }}
                </label>
                <select v-model="groupId" class="form-control">
                    <option value="">{{ t('automations-form-triggers_config-product_group_stock-group_placeholder') }}</option>
                    <option value="any">{{ t('automations-form-triggers_config-product_group_stock-any_group') }}</option>
                    <option
                        v-for="group in groups"
                        :key="group.id"
                        :value="group.id"
                    >
                        {{ group.name }}
                    </option>
                </select>
            </div>
            <div v-else>
                <span class="far fa-spinner fa-spin" /> {{ t('automations-form-triggers_config-product_group_stock-loading_groups') }}
            </div>
        </div>
        <div class="field" v-if="groupId">
            <label :class="{ label: true }"
                >{{ t('automations-form-triggers_config-product_group_stock-threshold_label') }}</label
            >
            <input
                type="number"
                required
                class="form-control"
                v-model="threshold"
            />
        </div>
    </div>
</template>
<style lang="less">
.filter-value {
    .row.inputs {
        margin-top: 10px;
    }
    input {
        margin-top: 4px;
    }
}
</style>
<script>
import keviApi from "../../../keviApi";

export default {
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        let groupId =
            this.value.length > 0 && this.value[0].groupId
                ? this.value[0].groupId
                : "";
        let threshold =
            this.value.length > 0 && this.value[0].threshold
                ? parseInt(this.value[0].threshold)
                : 0;

        return {
            groupId: groupId,
            groups: [],
            threshold,
        };
    },
    computed: {
        errors() {
            let errors = {};

            if (!this.groupId) {
                // i18n-validator-ignore-next-line: validation key
                errors["groupId"] = "select-group";
            }
            return errors;
        },
    },
    mounted: function () {
        let options = keviApi.getOptions("/products/groups", "GET");
        this.$http(options).then((response) => {
            this.groups = response.data.data;
            window.setTimeout(() => {
                this.changed();
            }, 100);
        });
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        isFieldValid(field) {
            return !Object.keys(this.errors).includes(field);
        },
        isValid: function () {
            return Object.keys(this.errors).length === 0;
        },
        changed: function () {
            this.$emit("input", [
                {
                    groupId: this.groupId,
                    threshold: this.threshold,
                },
            ]);
        },
    },
    watch: {
        groupId: function () {
            this.changed();
        },
        threshold: function () {
            this.changed();
        },
        filter: function () {
            this.changed();
        },

        value: function () {
            let groupId =
                this.value.length > 0 && this.value[0].groupId
                    ? this.value[0].groupId
                    : "";
            let threshold =
                this.value.length > 0 && this.value[0].threshold
                    ? parseInt(this.value[0].threshold)
                    : 0;

            if (groupId !== this.groupId) {
                this.groupId = groupId;
            }
            if (threshold !== this.threshold) {
                this.threshold = threshold;
            }
        },
    },
};
</script>
